export default __webpack_public_path__ + "static/media/leftarc.2171858e.svg";